<template>
  <div class="label">
    <div>
      <div v-if="draggable" class="draggable">
        <ButtonElement is-draggable-button class="btn-large"></ButtonElement>
      </div>
      <div v-else class="notDraggable" style="display: none;">
        <div></div>
      </div>

      <div class="icon" v-if="icon">
        <div class="iconBox">
          <LucideIcon :icon="icon" style="font-size: 18px"/>
        </div>
      </div>
      <div class="icon" v-if="svgClass">
        <div class="iconBox" :class="svgClass">
        
        </div>
      </div>
      <div class="content">{{ label }}</div>
    </div>
  </div>

</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { ButtonElement } from '@shared/components/elements';

export default defineComponent({
  name: 'FormGroupLabelSection',
  components: {
    ButtonElement,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    svg: {
      type: String,
      required: false,
    },
    svgClass: {
      type: String, 
      required: false
    },
    iconType: {
      type: String,
      required: false,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.form-group {
  width: 100%;
  margin-bottom: 15px;

  & .draggable {
    display: flex;
    align-items: center;
    height: 100%;
  }

  & .notdraggable {
    display: flex;
    align-items: center;
    height: 100%;
  }

  & .label {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;

    & > div {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;

      & > .icon {
        display: flex;
        align-items: center;
        width: 50px;
      }

      & > .content {
        width: 100%;
        font-size: var(--fs-14);
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }
}

.notDraggable {
  width: 25px;
  height: 40px;
  margin-right: 5px;

  div {
    width: 25px;
    height: 40px;
    margin-right: 5px;
  }
}

.iconBox {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  &.google{
      &::before{
        content: '';
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="24" width="24"><path fill="%234285f4" d="M386 400c45-42 65-112 53-179H260v74h102c-4 24-18 44-38 57z"></path><path fill="%2334a853" d="M90 341a192 192 0 0 0 296 59l-62-48c-53 35-141 22-171-60z"></path><path fill="%23fbbc02" d="M153 292c-8-25-8-48 0-73l-63-49c-23 46-30 111 0 171z"></path><path fill="%23ea4335" d="M153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55z"></path></svg>');
        width: 24px;
        height: 24px;
        display: flex;
        margin-right: 10px;
      }
    }
    &.linkedin{
      &::before{
        content: '';
        background-image:url('data:image/svg+xml,<svg fill="%230E4FB5" height="18" width="18" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 310 310" xml:space="preserve"><g id="XMLID_801_"><path id="XMLID_802_" d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73C77.16,101.969,74.922,99.73,72.16,99.73z"/><path id="XMLID_803_" d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"/><path id="XMLID_804_" d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995C310,145.43,300.549,94.761,230.454,94.761z"/></g></svg>');
        width: 18px;
        height: 18px;
        display: flex;
        margin-right: 10px;
        position: relative;
        top: -1px;
      }
    }
}

</style>
